<template>
  <div class="form-group">
    <input
      type="text"
      class="hidden-select-field"
      :name="name"
      :value="code"
      data-required-if-visible
    />

    <VueSelect
      v-model="selectedValue"
      class="form-control"
      placeholder="2Simple Contact"
      :clearable="true"
      :filterable="true"
      :options="options"
    />
  </div>
</template>

<script setup lang="ts">
import { useRegionHelper } from "@/common/region_helper";
import { fetchLeadCapturePersons } from "@/lib/fetchLeadCapturePersons";
import { computed, onMounted, ref } from "vue";
import VueSelect from "vue-select";

type Option = {
  code: string;
  label: string;
};

type Props = {
  name: string;
};

defineProps<Props>();

const options = ref<Option[]>([]);
const selectedValue = ref<Option | null>(null);
const region = useRegionHelper();

const code = computed<string>(() => selectedValue.value?.code ?? "");

onMounted(() => {
  loadLeadCapturePersons();
});

async function loadLeadCapturePersons() {
  try {
    const userRegion = region.getSelectedRegion();
    const persons = await fetchLeadCapturePersons(userRegion.country_code);
    options.value = persons.map((p) => ({ code: p.id, label: p.name }));
  } catch (error) {
    console.error("Error while fetching lead capture persons list.", error);
    options.value = [];
  }
}
</script>
